import { fetchStoresAroundRenderingService } from "../api/store-search-result-service";
import { customerLocality, DATA_SELECTOR_ID, IS_USER_CONTEXTUALIZED, STORE_SEARCH_RESULTS, storeContextTracking } from "../utils/context-layer-variables";
import { clearErrorMessage, insertErrorMessage } from "./search-errors";
import { pushStoreSearchEventsTracking } from "./tracking";
import { createCustomerContextCookie } from "../api/customer-context-cookie-service";
import { initDecreasedViewListener } from "./decreased-store-search";
import { Coordinates } from "../models/Coordinates";
export function fetchStoresAroundRendering(storeSearchResultData, storeSearchContainer) {
  const storeSearchLoaderContainer = storeSearchContainer.querySelector(`[${DATA_SELECTOR_ID}="store-search-loader"]`);
  const storeSearchResultContainer = storeSearchContainer.querySelector(`[${DATA_SELECTOR_ID}="${STORE_SEARCH_RESULTS}"]`);
  if (storeSearchLoaderContainer) storeSearchLoaderContainer.style.display = 'block';
  return new Promise((resolve, reject) => {
    fetchStoresAroundRenderingService(storeSearchResultData, resultTemplate => {
      clearErrorMessage(storeSearchContainer);
      resolve(resultTemplate);
    }, err => {
      if (storeSearchResultContainer) storeSearchResultContainer.innerHTML = '';
      insertErrorMessage(storeSearchContainer, context_layer.i18n.store_search_error);
      initDecreasedViewListener();
      reject(err);
    }, () => {
      if (storeSearchLoaderContainer) storeSearchLoaderContainer.style.display = 'none';
    });
  });
}
export function integrateHtmlToStoreSearchBlock(storesResultView, storeSearchBlock) {
  const storeSearchResultBlock = storeSearchBlock.querySelector(`[${DATA_SELECTOR_ID}="${STORE_SEARCH_RESULTS}"]`);
  if (storeSearchResultBlock) storeSearchResultBlock.innerHTML = storesResultView;
}
export function applySeeMyStoreLinkTracking(storeSearchContainer, trackingFunnelName) {
  const storePageLinks = storeSearchContainer.querySelectorAll(`[${DATA_SELECTOR_ID}="store-info-link"]`);
  storePageLinks === null || storePageLinks === void 0 ? void 0 : storePageLinks.forEach(element => {
    element.addEventListener('click', () => {
      pushStoreSearchEventsTracking("see more about my store", "Contextualisation", trackingFunnelName);
    });
  });
}
export function initStoreContextualizationEvent(customerContext, storeSearchContainer, trackingFunnelName) {
  const chooseMyStoreButtons = storeSearchContainer.querySelectorAll(`[${DATA_SELECTOR_ID}="store-context-button"]`);
  chooseMyStoreButtons === null || chooseMyStoreButtons === void 0 ? void 0 : chooseMyStoreButtons.forEach(button => {
    button.addEventListener('click', () => {
      var _a, _b, _c, _d, _e, _f;
      const storeId = (_b = (_a = button.attributes) === null || _a === void 0 ? void 0 : _a.getNamedItem('data-store-id')) === null || _b === void 0 ? void 0 : _b.value;
      if (!customerContext.getCoordinates()) {
        const latitude = (_d = (_c = button.attributes) === null || _c === void 0 ? void 0 : _c.getNamedItem('data-store-latitude')) === null || _d === void 0 ? void 0 : _d.value;
        const longitude = (_f = (_e = button.attributes) === null || _e === void 0 ? void 0 : _e.getNamedItem('data-store-longitude')) === null || _f === void 0 ? void 0 : _f.value;
        if (latitude && longitude) customerContext = customerContext.withCoordinates(new Coordinates(+latitude, +longitude));
      }
      if (storeId) {
        createCustomerContextCookie(customerContext.withMainStoreId(+storeId), () => {
          pushStoreSearchEventsTracking('Choose localisation', "Contextualisation", trackingFunnelName);
          localStorage.setItem(IS_USER_CONTEXTUALIZED, 'true');
          window.location.reload();
        });
      }
    });
  });
}
export function initStoreSearchResultEvents(customerContext, storeSearchContainer, storesResultView) {
  var _a, _b;
  customerLocality.customerContextPostcode = (_a = customerContext.getPostcode()) !== null && _a !== void 0 ? _a : '';
  customerLocality.customerContextCity = (_b = customerContext.getCity()) !== null && _b !== void 0 ? _b : '';
  integrateHtmlToStoreSearchBlock(storesResultView, storeSearchContainer);
  applySeeMyStoreLinkTracking(storeSearchContainer, storeContextTracking.funnelName);
  initStoreContextualizationEvent(customerContext, storeSearchContainer, storeContextTracking.funnelName);
}